import { createSlice } from "@reduxjs/toolkit";

import { WithdrawalPolicyData } from "@/types/withdrawal";

import {
  getWithdrawalPolicy,
  submitWithdrawalRequestAction,
} from "./withdrawal.action";

interface WithdrawalState {
  policyData: WithdrawalPolicyData | null;
  isLoadingPolicy: boolean;
  isSubmittingRequest: boolean;
  policyError: string | null;
  requestError: string | null;
  requestSuccess: boolean;
}

const initialState: WithdrawalState = {
  policyData: null,
  isLoadingPolicy: false,
  isSubmittingRequest: false,
  policyError: null,
  requestError: null,
  requestSuccess: false,
};

const withdrawalSlice = createSlice({
  name: "withdrawal",
  initialState,
  reducers: {
    resetWithdrawalState: () => initialState,
    clearRequestState: (state) => {
      state.requestError = null;
      state.requestSuccess = false;
      state.isSubmittingRequest = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWithdrawalPolicy.pending, (state) => {
      state.isLoadingPolicy = true;
      state.policyError = null;
    });

    builder.addCase(getWithdrawalPolicy.fulfilled, (state, action) => {
      state.isLoadingPolicy = false;
      state.policyData = action.payload;
      state.policyError = null;
    });

    builder.addCase(getWithdrawalPolicy.rejected, (state, action) => {
      state.isLoadingPolicy = false;
      state.policyError =
        (action.payload as { message: string })?.message ||
        "Failed to load policy data";
    });

    builder.addCase(submitWithdrawalRequestAction.pending, (state) => {
      state.isSubmittingRequest = true;
      state.requestError = null;
      state.requestSuccess = false;
    });

    builder.addCase(
      submitWithdrawalRequestAction.fulfilled,
      (state, action) => {
        state.isSubmittingRequest = false;
        state.requestError = null;
        state.requestSuccess = true;
        state.policyData = action.payload; // Update policyData with the response from the withdrawal request
      }
    );

    builder.addCase(submitWithdrawalRequestAction.rejected, (state, action) => {
      state.isSubmittingRequest = false;
      state.requestError =
        (action.payload as { message: string })?.message ||
        "Failed to submit withdrawal request";
      state.requestSuccess = false;
    });
  },
});

export const { resetWithdrawalState, clearRequestState } =
  withdrawalSlice.actions;
export default withdrawalSlice.reducer;
